import { memo } from "react";
import {
  MonthlyDTO,
  PaymentChargedDTO,
  TotalChargedDTO,
  WeeklyDTO,
} from "@zenith/services/transactions";
import { DEFAULT_CURRENCY_SYMBOL } from "@zenith/data/constants";
import { PieChartComponent } from "@zenith/features/Analytics";

/* eslint-disable-next-line */
export interface PaymentMethodSalesComponentProps {
  data: WeeklyDTO | MonthlyDTO | undefined;
}

const PaymentMethodSalesComponent = memo(function PaymentMethodSalesComponent(
  props: PaymentMethodSalesComponentProps
) {
  const { data } = props;

  return (
    <div className="grid w-full grid-cols-1 gap-3 lg:grid-cols-2">
      <div className="">
        <div className="mb-4 items-center justify-start pl-4 pr-2 text-xl font-medium leading-7 text-zinc-900">
          Sales Value by Payment Method ({DEFAULT_CURRENCY_SYMBOL})
        </div>
        <PieChartComponent
          data={data?.paymentCharged as PaymentChargedDTO[]}
          totalValueData={data?.totalCharged as TotalChargedDTO}
          isQuantity={false}
        />
      </div>

      <div className="">
        <div className="mb-4 items-center justify-start pl-4 pr-2 text-xl font-medium leading-7 text-zinc-900">
          Number of Sales by Payment Method
        </div>
        <PieChartComponent
          data={data?.paymentCharged as PaymentChargedDTO[]}
          totalValueData={data?.totalCharged as TotalChargedDTO}
          isQuantity={true}
        />
      </div>
    </div>
  );
});

export default PaymentMethodSalesComponent;
